/* eslint-disable jsx-a11y/media-has-caption */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getVideoPlaybackStyle } from './style';

// since the <video> didn't support the stream play directly, so will using one link in DownloadUrl instead of the url as src.
export const VideoPlaybackView = (props) => {
  const {
    height,
    width,
    src,
    thumbnailUrl,
    hideControls,
    onLoadedMetadata,
    onErrorHanler,
  } = props;

  const classes = useDefaultStyles(getVideoPlaybackStyle);
  const useDynamicVideoSize = !(width > 0 || height > 0);

  const onError = useCallback((ev) => {
    const errorCode = ev && ev.target && ev.target.error.code;
    onErrorHanler(errorCode);
  }, [onErrorHanler]);

  return (
    <div className={classnames(useDynamicVideoSize && classes.dynamicSizeContainer, 'video-playback-view')}>
      <video
        width={width}
        height={height}
        poster={thumbnailUrl}
        controls={!hideControls}
        onLoadedMetadata={onLoadedMetadata}
        onError={onError}
        src={src}
        controlsList="nodownload nofullscreen"
        disablePictureInPicture
      />
    </div>);
};

VideoPlaybackView.propTypes = {
  src: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string,
  hideControls: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
  onErrorHanler: PropTypes.func,
  onLoadedMetadata: PropTypes.func,
};

VideoPlaybackView.defaultProps = {
  thumbnailUrl: null,
  hideControls: false,
  width: undefined,
  height: undefined,
  onErrorHanler: _.noop,
  onLoadedMetadata: _.noop,
};
